<template>
    <div>
        <div class="cards">
            <div class="card-l" @click="toBk">
                <img src="../../../assets/khbk.png">
            </div>
            <div class="card-r"@click="toXk">
                <img src="../../../assets/khcz.png">
            </div>
        </div>
        <div class="cards">
            <div class="cards-y" @click="toTcs">
                <img src="../../../assets/y.png">
            </div>
            <div class="cards-e">
                <img src="../../../assets/e.png">
            </div>
            <div class="cards-s" @click="toXfs">
                <img src="../../../assets/s.png">
            </div>
        </div>
        <van-popup v-model="bkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Bk v-if="bkShow" ref="bk" @gbBk="gbBk"  :memberId="memberId"/>
        </van-popup>
        <van-popup v-model="xkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Xk v-if="xkShow" ref="xk" @gbXk="gbXk"  :memberId="memberId"/>
        </van-popup>
    </div>
</template>

<script>
    // import {getCookie} from "../../../utils/auth";
    import Bk from "./card";
    import Xk from "./recharge";
    export default {
        components: {Bk,Xk},
        data() {
            return {
                deptId:'',
                token:'',

                bkShow:false,
                xkShow:false,
            };
        },
        props:{
            memberId:String
        },
        async created() {

        },
        methods: {
            onClick(){
            },
            toBk(){
                this.bkShow=true
            },
            gbBk(){
                this.bkShow=false
            },
            toXk(){
                this.xkShow=true
            },
            gbXk(){
                this.xkShow=false
            },
            toTcs(){
                this.$router.push('/fwMdTc?memberId='+this.memberId)
            },
            toXfs(){
                this.$router.push('/fwMdCmp?memberId='+this.memberId)
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .cards{
        display: flex;
        flex-direction: row;
    }
    .card-l{
        width: 73%;
        margin:  8px 8px 3px 8px;
    }
    .card-r{
        width: 27%;
        margin: 8px 8px 3px 0;
    }
    .cards-y{
        width: 33.3%;
        margin-left: 8px;
    }
    .cards-e{
        width: 33.3%;
        margin: 0 8px;
    }
    .cards-s{
        width: 33.3%;
        margin-right: 8px;
    }
</style>